import { coreServiceUrl } from '../../../config/environment';
import { callApi } from '../../../utils/callApi';
import { ArticleDefinition } from '../core-service.types';

/** @deprecated – place into configurator state */
export const getMultipleArticleDefinitions = async (
  articleOrProductNumbers: string[],
): Promise<CoreServiceAPI.ArticleDefinitionDto[]> => {
  const { data } = await callApi<ArticleDefinition[]>(
    `${coreServiceUrl}/wsc/articles/get-definitions`,
    'post',
    articleOrProductNumbers,
  );
  return data.map((definition) => ({
    articleNumber: definition.number,
    definition,
  })) as CoreServiceAPI.ArticleDefinitionDto[];
};
